/**
 *
 * @param {Object[]} dealerCodes - an array of possible dealer id objects
 * @param {string} targetId  - the key of the desired dealer code
 * @returns value of targetId or '' if not found
 */
const findDealerCode = (dealerCodes, targetId) => {
	const storedObject = Object.values(dealerCodes).find((val) =>
		Object.prototype.hasOwnProperty.call(val, targetId)
	);
	return typeof storedObject === 'undefined'
		? ''
		: storedObject[targetId].toString();
};

export default findDealerCode;
